/* RESPONSIBLE TEAM: team-frontend-tech */
import { helper as buildHelper } from '@ember/component/helper';
export default buildHelper(function add(params) {
  return params.reduce((a, b) => Number(a) + Number(b));
});
